export default "__VITE_ASSET__CkBjaRgJ__"